export enum FilterDataType {
	OBS = 'obs', // Osmatranje / Observation
	SCP = 'scp', // Projekcija / Model
}
